module.exports = __webpack_public_path__ + "img/home_logo.7ee3802c.svg";